import { useCreateCtx } from '@cleartax/wg-library-hooks';
import { Dispatch, SetStateAction } from 'react';
import { IPartnerPlanData } from '../types';

export interface IPartnerPageContext {
  selfITRPlansData: IPartnerPlanData[];
  setSelfITRPlansData: Dispatch<SetStateAction<IPartnerPlanData[]>>;
}

export const [usePartnerPageContext, PartnerPageProvider] =
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useCreateCtx<IPartnerPageContext>();
